import { render } from "./addcategory.vue?vue&type=template&id=559c1f6b"
import script from "./addcategory.vue?vue&type=script&lang=js"
export * from "./addcategory.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__